// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 PRO React components
import MKTypography from "../../../components/MKTypography";

// Images
import logoCT from "../../../assets/images/illustration-reset.jpg";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Plataforma Gamificada",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/AdsLiveMedia",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "about us", href: "https://www.adslivemedia.com" }
      ],
    }
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Gamification Platform by{" "}
      <MKTypography
        component="a"
        href="https://www.adslivemedia.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Adslive Media
      </MKTypography>
      .
    </MKTypography>
  ),
};
